import { Mesh, Scene } from 'three';

import type { QualitySettings } from '../../../../hooks/use-three-kitchen/quality';
import { isInterfaceObject } from './is-interface-object.helper';

/**
 * Traverse scene and update all materials based on quality settings
 * Wireframe mode (quality 0) applies to all scene objects EXCEPT interface elements
 * Interface elements (light helpers, camera helpers, debug visuals) stay at quality 1
 */
export const updateMaterialsForQuality = (scene: Scene, qualitySettings: QualitySettings): void => {
	const wireframe = qualitySettings.wireframe;

	scene.traverse((object) => {
		if (object instanceof Mesh && object.material) {
			// Skip interface objects - they should never be wireframed
			if (isInterfaceObject(object)) {
				return;
			}

			const materials = Array.isArray(object.material) ? object.material : [object.material];

			materials.forEach((mat: any) => {
				// Check if material supports wireframe property (most mesh materials do)
				// This covers MeshStandardMaterial, MeshPhysicalMaterial, MeshBasicMaterial,
				// MeshLambertMaterial, MeshPhongMaterial, etc.
				if ('wireframe' in mat) {
					mat.wireframe = wireframe;
					mat.needsUpdate = true;
				}
			});
		}
	});
};
